import { styled } from '@ui/utils/style.util';

const BaseStandardDetailBox = styled(
  'article',
  'overflow-hidden rounded-[5px] border border-grey-input-border',
);
BaseStandardDetailBox.displayName = 'StandardDetailBox';

export const StandardDetailBoxDisabled = styled(
  'article',
  'min-h-[86px] max-h-[208px] overflow-y-auto p-3 rounded-[5px] border border-grey-input-border bg-grey-disabled space-y-2.5',
);
StandardDetailBoxDisabled.displayName = 'StandardDetailBoxDisabled';

const StandardDetailBox = Object.assign(BaseStandardDetailBox, {
  Disabled: StandardDetailBoxDisabled,
});

export default StandardDetailBox;
